import { User } from '@redux/prop-types';

const isUserNotEnrolled = (user: User) => {
  return !user?.source;
};

const isNacionalUserNotEnrolled = (user: User) => {
  return (
    (isUserNotEnrolled(user) && user?.group?.includes('nacional-')) ||
    (user?.source?.includes('nacional-') && !user?.group)
  );
};

const isUserPIorPR = (user: User) => {
  return (
    user?.source === 'nacional-pi-I-02/2025' ||
    user?.source === 'nacional-pr-I-02/2025'
  );
};

const hasUserCompletedMundoTech = (user: User) => {
  return user?.completedChallenges?.some(
    (challenge: { id: string }) => challenge.id === '66fbe66d4368241d29757851'
  );
};

const isUserReproved = (user: User): boolean => {
  return !!user?.studentEvaluation && user?.studentEvaluation?.studentGrade < 7;
};

const isUserApproved = (user: User) => {
  return (
    !user?.needsPlacementTest &&
    user?.studentEvaluation &&
    user.studentEvaluation.studentGrade >= 7
  );
};

const isNumberOfAttemptsOver = (user: User) => {
  return (
    user?.attemptedPlacementTestCounter &&
    user.attemptedPlacementTestCounter >= 2
  );
};

const isNumberOfAttemptsNotOver = (user: User) => {
  return (user.attemptedPlacementTestCounter ?? 0) < 2;
};

const isUserSecondChancePlacementTest = (user: User) => {
  return (
    isNacionalUserNotEnrolled(user) &&
    isNumberOfAttemptsNotOver(user) &&
    user?.registrationQuiz === 1 &&
    user?.completedChallenges?.length === 0 &&
    !user?.needsPlacementTest
  );
};

const isPROrPIReproved = (user: User): boolean => {
  return isUserPIorPR(user) && isUserReproved(user);
};

const needsPlacementTest = (user: User) => {
  return (
    user?.needsPlacementTest ||
    (user.registrationQuiz === 1 &&
      !user.isFundamentosDaProgramacaoFrontEndCert &&
      hasUserCompletedMundoTech(user) &&
      isNumberOfAttemptsNotOver(user))
  );
};

const mustUserDoPlacementTest = (user: User) => {
  return (
    (isNacionalUserNotEnrolled(user) || isUserPIorPR(user)) &&
    needsPlacementTest(user)
  );
};

const isNumberOfAttemptsOverAndReproved = (user: User) => {
  return (
    isNacionalUserNotEnrolled(user) &&
    user?.registrationQuiz === 1 &&
    isNumberOfAttemptsOver(user) &&
    isUserReproved(user)
  );
};

const isUserOnWaitingList = (user: User) => {
  return isNacionalUserNotEnrolled(user) && isUserApproved(user);
};

export {
  isNacionalUserNotEnrolled,
  isNumberOfAttemptsOverAndReproved,
  isPROrPIReproved,
  isUserNotEnrolled,
  isUserOnWaitingList,
  isUserPIorPR,
  isUserSecondChancePlacementTest,
  mustUserDoPlacementTest
};
